import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faEye } from '@fortawesome/free-solid-svg-icons'
import { RegistroClientes } from './RegistroClientes'
import { ListaClientes } from './ListaClientes'

export const Clientes = () => {

    const [clienteEditar, setClienteEditar] = useState(null);

    const [menu, setMenu] = useState([
        { element: 'buttom1', label: 'Mis clientes', icon: faEye, class: 'btn btn-link p-menu-selector-agenda-active', state: true },
        { element: 'buttom2', label: 'Nuevo registro', icon: faPlus, class: 'btn btn-link p-menu-selector-agenda', state: false },
    ])

    const executeMenu = (e) => {
        if (e.target.name === 'buttom1') {
            setClienteEditar(null);
        }
        setMenu((elements) => {
            const hMap = elements.map((element) => {
                element.class = (e.target.name === element.element) ? 'btn btn-link p-menu-selector-agenda-active' : 'btn btn-link p-menu-selector-agenda'
                element.state = (e.target.name === element.element) ? true : false
                return element
            })
            return hMap;
        });
    }

    const handleEditarCliente = (cliente) => {
        setClienteEditar(cliente);
        executeMenu({
            target: {
                name: 'buttom2'
            }
        });
    };

    const displayMenu = () => {
        let object = {};
        menu.map((element) => {
            if (element.state) {
                object = element;
            }
            return object;
        })
        switch (object.element) {
            case 'buttom1':
                return (
                    <ListaClientes onEditarCliente={handleEditarCliente} />
                )
            case 'buttom2':
                return (
                    <RegistroClientes clienteEditar={clienteEditar} executeMenu={executeMenu} />
                )
            default:
                return (
                    <></>
                )
        }
    }

    return (
        <>
            <div className='div-container-db-agenda' >
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                        <div className=''>
                            <h1 className='size-db-info-agenda-h1'>
                                Gestiona tus clientes:
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="">
                    <p className='p-label-form mt-3'>Administra la información de tus clientes y agenda sus citas de manera sencilla y eficiente. </p>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-2" ></div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-8" >
                        <div className="div-menu-selector-agenda-container">
                            <div className="div-menu-selector-agenda">
                                {
                                    menu.map((object, index) => {
                                        return (
                                            <button key={index} name={object.element} className={object.class} onClick={executeMenu} >
                                                <FontAwesomeIcon icon={object.icon} /> {object.label}
                                            </button>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-2" ></div>
                </div>
            </div>
            <div className='div-container-db-agenda mt-2'>
                {
                    displayMenu()
                }
            </div >
        </>

    )
}
